import React from 'react';
import { Poppins } from 'src/common';
import { AuditTableArrow } from 'src/assets/dynamicSvg';
import * as S from './Switch.styles';

interface ISwitchProps {
  showHistory: boolean;
  setShowHistory: (a: boolean) => void;
  title?: string;
  dataCy?: string;
}

export const Switch: React.FC<ISwitchProps> = ({ showHistory, setShowHistory, title, dataCy = 'audit-switch' }) => {
  return (
    <S.Div showHistory={showHistory} data-cy={dataCy}>
      <div className="button" onClick={() => setShowHistory(!showHistory)}>
        <span>
          <Poppins weight={500} color="prussianBlue" px={18}>
            {title ? title : <>{showHistory ? 'Hide' : 'Show'} History</>}
          </Poppins>
        </span>
        <AuditTableArrow />
      </div>
    </S.Div>
  );
};
